import * as Sentry from '@sentry/vue';

import { BaseStore, StoreFlags } from './_base';

import { Institution, institutionService } from '../services/institutions';

import { isAuthenticated } from '../globals/helpers';


class InstitutionStore extends BaseStore<Institution> {
  async getInstitution(): Promise<Institution> {
    return (await this.retrieveAllLocalOrRemote())[0].entry;
  }

  async retrieveAll(forceRetrieval = false): Promise<undefined> {
    if (!isAuthenticated()) return;
    const accessTokenAtStart = localStorage.getItem('accessToken');

    // Only retrieve settings again, if at least half of the update interval passed
    const skipSettingsUpdate = (
      !forceRetrieval &&
      this.lastUpdate() &&
      (Number(new Date()) - Number(this.lastUpdate())) / 1000 < this.updateInterval / 2
    );

    await super.retrieveAll(forceRetrieval);
    if (localStorage.getItem('accessToken') !== accessTokenAtStart) return;

    // if (skipSettingsUpdate) return;
    // if (this.count() == 0) return;

    // Cache settings as well
    if (this.list().length === 0) return;

    try {
      const institutionId = this.list()[0].entry.id;
      const response = await institutionService.retrieveSettings(institutionId);
      if (localStorage.getItem('accessToken') !== accessTokenAtStart) return;
      if (!response) return;
      const settings = response.data;
      const activeSettings = {};
      const now = (new Date()).toISOString();
      for (const categoryId in settings) {
        for (const settingId in settings[categoryId]) {
          for (const item of settings[categoryId][settingId]) {
            if (item.valid_from <= now && (!item.valid_before || now < item.valid_before)) {
              activeSettings[categoryId] = activeSettings[categoryId] || {};
              activeSettings[categoryId][settingId] = item.value;
            }
          }
        }
      }
      const settingsRaw = JSON.stringify(activeSettings);
      const key = this.getResourceName() + "__settings";
      localStorage.setItem(key, settingsRaw);
    } catch (err: any) {
      if (localStorage.getItem('accessToken') !== accessTokenAtStart) return;
      if (err?.response?.status === 403) return;
      if (err?.name === 'QuotaExceededError') return;
      Sentry.captureException(err, { tags: { source: 'InstitutionStore.retrieveAll' } });
    }
  }

  settings(): any {
    const key = this.getResourceName() + "__settings";
    const settingsRaw = localStorage.getItem(key);

    return settingsRaw ? JSON.parse(settingsRaw) : {};
  }
}

export const institutionStore = new InstitutionStore("institutions", institutionService, 60 * 60 * 24 * 2, new Set([StoreFlags.RETRIEVE_ALL]));
